// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Item from './item';
import { CONFIG } from "~/config";

/**
 * @class Jedna polozka vysledku hledani v pravem sloupci
 * @augments JAK.ISignals
 */
export default class ItemCorrection extends Item {
	constructor(owner, correction) {
		super(owner, { source: "coor", id: "" }, 0, correction);
	}

	destroy() {
		this._dom.container.removeEventListener("click", this, false);
	}

	handleEvent(e) {
		if (!Mapy.Util.linkToNewWindow(e)) {
			e.preventDefault();
			Mapy.getComponent("search").setCorrection(e.target.getAttribute("data-log-text"));
			Mapy.getComponent("history").save();
		}
	}

	_build() {
		this._dom.container = node("div", {className:"correction"});

		var box = node("p", {className:"content"});

		this._correction.quote.forEach(function(item) {
			var el;

			switch (item.type) {
				case "text":
					el = document.createTextNode(item.value);
					break;

				case "bold":
					el = Mapy.Util.node("strong", { textContent: item.value });
					break;

				case "link":
					el = this._createLink(item.value);
					break;
			}
			box.appendChild(el);
		}.bind(this));

		this._dom.container.appendChild(box);
	}

	_createLink(txt) {
		var anchor = node("a", {href: "https://" + CONFIG.BASE_URL + "/?q=" + txt });
		anchor.setAttribute("data-log-action", "correction");
		anchor.setAttribute("data-log-q", Mapy.getComponent("search").getQuery().trim().toLowerCase());
		anchor.setAttribute("data-log-text", txt);
		anchor.setAttribute("data-log-lang", CONFIG.defaultLang);
		anchor.setAttribute("data-log-click", "1");
		anchor.setAttribute("data-log-type", this._correction.correctorId);
		anchor.appendChild(JAK.ctext(txt));
		anchor.addEventListener("click", this, false);

		return anchor;
	}
};
